<template>
    <select class="form-control font-weight-bold" v-model="valor" @change="$emit('evento', valor)">
        <option value="">Seleccione Combustible...</option>
        <option v-for="d in dataCombustible" :key="d.Id" :value="d.descripcion">{{d.tipo +'____'+d.descripcion }}
        </option>
    </select>
</template>

<script>
    export default {
        name: "SelectTipoCombustible",
        props: ['valor_entrada', 'tipo'],
        data() {
            return {
                valor: '',
                data: []
            }
        },
        beforeMount() {
            setTimeout(() => {

                this.valor = this.valor_entrada;
            }, 100);
        },
     
        watch: {

            valor_entrada(newQuestion, oldQuestion) {
                this.valor = newQuestion;

            }
        },
        computed: {
            dataCombustible() {

                if (this.tipo == 'glp') {
                    return this.$store.state.dataCombustibleTipo.filter((el) => {
                        if (el.tipo == 'GLP') {
                            return el;
                        }
                    });
                } else if(this.tipo == 'gnv') {
                    return this.$store.state.dataCombustibleTipo.filter(elemento => elemento.tipo === 'GNV');
                }else{
                    return this.$store.state.dataCombustibleTipo.filter(elemento => elemento.tipo === 'TRIMOVIL');
                }

            }
        }

    }
</script>